import { type AnyChainflipAsset } from '@chainflip/utils/chainflip';

// positive decimals only, dont allow two leading zeros or multiple "."
export const POSITIVE_DECIMALS_REGEX = /(^(?!00)\d+([.]\d*)?$)|(^$)/;

export const SIGNED_INTEGERS_REGEX = /^[+-]?\d+$/;

export const decimalRegex = (decimals = 18): RegExp =>
  new RegExp(String.raw`^$|^\d+(\.\d{0,${decimals}}$|$)`);

export const PERIOD_WITH_TRAILING_ZEROS = /\.0*$/;
export const ALL_ZEROS = /^0+$/;
export const LEADING_ZEROS = /^0+(?=[1-9])/;
export const TRAILING_ZEROS = /(\d+\.[1-9]+)0*$/;

export const NUMBER_REGEX = /^\d+$/;
export const SS58_REGEX = /^cF/i;

export const ASSET_REGEX: Record<AnyChainflipAsset, RegExp> = {
  HubDot: /^a?s?s?e?t?hub ?p?o?l?k?a?dot$/i,
  HubUsdc: /^a?s?s?e?t?hub ?usdc$/i,
  HubUsdt: /^a?s?s?e?t?hub ?usdt$/i,
  ArbEth: /^arbi?t?r?u?m? ?ethe?r?e?u?m?$/i,
  ArbUsdc: /^arbi?t?r?u?m? ?usdc$/i,
  ArbUsdt: /^arbi?t?r?u?m? ?usdt$/i,
  SolUsdc: /^sola?n?a? ?usdc$/i,
  SolUsdt: /^sola?n?a? ?usdt$/i,
  Sol: /^sola?n?a?$/i,
  Btc: /^bi?tco?i?n?$/i,
  Eth: /^ethe?r?e?u?m?$/i,
  Wbtc: /^wbtc$/i,
  Usdc: /^usdc$/i,
  Usdt: /^usdt$/i,
  Flip: /^flip$/i,
  Dot: /^p?o?l?k?a?dot$/i,
  Trx: /^t?r?o?n?$/i,
  TrxUsdt: /^t?r?o?n? ?usdt$/i,
  Cbbtc: /^cb ?btc$/i,
  Bnb: /^bnb$/i,
  BscUsdt: /^bsc ?usdt$|^bnb ?(smart ?)?chain ?usdt$/i,
};
